import { useCallback } from "react"
import { useMutation } from "react-relay"
import type {
  Ch_deleteEpisodesOfCareInput,
  chDeleteEpisodesOfCareMutation,
} from "@/modules/patients/services/ch/__generated__/chDeleteEpisodesOfCareMutation.graphql"
import { chDeleteEpisodesOfCareMutation as chMutation } from "@/modules/patients/services/ch/chDeleteEpisodesOfCareMutation"
import type {
  De_deleteEpisodesOfCareInput,
  deDeleteEpisodesOfCareMutation,
} from "@/modules/patients/services/de/__generated__/deDeleteEpisodesOfCareMutation.graphql"
import { deDeleteEpisodesOfCareMutation as deMutation } from "@/modules/patients/services/de/deDeleteEpisodesOfCareMutation"
import { Country } from "@/types/__generated__/union-types"

export const useDeleteEpisodesOfCare = (country: Country) => {
  const mutation = country === "CH" ? chMutation : deMutation

  const [commit] = useMutation<chDeleteEpisodesOfCareMutation & deDeleteEpisodesOfCareMutation>(mutation)

  return useCallback(
    (
      input: De_deleteEpisodesOfCareInput | Ch_deleteEpisodesOfCareInput,
      connectionId: string,
      onCompleted?: () => void,
    ) => {
      commit({
        variables: {
          input,
          connections: [connectionId],
        },
        onCompleted(response) {
          const data = response.deleteEpisodesOfCare
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}
